import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MealsListing from "@components/ui/customDropdowns/MealsListing.jsx";
import FoodPreparingAdvice from "@features/diet/FoodPreparingAdvice.jsx";
import AllMeals from "@features/diet/AllMeals.jsx";
import MealPlanLoader from "@features/diet/MealPlanLOader.jsx";
import ActualDietPlanLoader from "@components/ui/Loaders/ActualDietPlanLoader.jsx";
import MainHeader from "@components/ui/MainHeader.jsx";
import { DietPlanHeader } from "@utils/defaultImages";
import { useDietPlanData } from "hooks/useDietPlanData";

const DietPlan = () => {
  const {
    isMealPlanLoading,
    firstLoad,
    dietPdfUrl,
    planPending,
    recreatePlan,
    pdfGenerating,
    message,
    setMessage,
    selectedDay,
    setSelectedDay,
    date,
    setDate,
    changeInDay,
    planInitiateTime,
    adviceList,
    mealList,
    recipes,
    weeklyMeals,
    initialSelectedMeal,
    startDate,
    tab,
    setTab,
    timeLeft,
    setTimeLeft,
    stopCountdown,
    fetchDietPlan,
    handleDietPlanFailed,
    handleSetDietPlan,
    t,
  } = useDietPlanData();

  if (firstLoad) return <ActualDietPlanLoader />;

  return (
    <div className="space-y-6">
      {isMealPlanLoading ? (
        <MealPlanLoader
          planInitiateTime={planInitiateTime}
          fetchDietPlan={fetchDietPlan}
          handleDietPlanFailed={handleDietPlanFailed}
          timeLeft={timeLeft}
          setTimeLeft={setTimeLeft}
          stopCountdown={stopCountdown}
          message={message}
          setMessage={setMessage}
        />
      ) : (
        <div className="!mt-0">
          <MainHeader
            heading={t(`dietPlanDashboard.dashboardHeaderHeading`)}
            subheading={t(`dietPlanDashboard.dashboardHeaderSubHeading`)}
            description={t(`dietPlanDashboard.dashboardHeaderdescription`)}
            Image={DietPlanHeader}
          />

          <div className="mt-6">
            {planPending && (
              <MealPlanLoader
                planInitiateTime={planInitiateTime}
                handleDietPlanFailed={handleDietPlanFailed}
                fetchDietPlan={fetchDietPlan}
                recreateLoading={true}
                timeLeft={timeLeft}
                setTimeLeft={setTimeLeft}
                stopCountdown={stopCountdown}
                message={message}
                setMessage={setMessage}
              />
            )}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-[100%] my-5">
            <div className="bg-white shadow-lg p-4 lg:p-6 rounded-lg w-full">
              {mealList.length > 0 &&
                initialSelectedMeal &&
                weeklyMeals.length > 0 && (
                  <MealsListing
                    initialSelectedMeal={initialSelectedMeal}
                    weeklyMeals={weeklyMeals}
                    day={selectedDay}
                    tab={tab}
                    setTab={setTab}
                    startDate={startDate}
                  />
                )}
            </div>

            <div className="bg-white shadow-lg p-6 rounded-lg w-full">
              {recipes.length > 0 && (
                <AllMeals
                  recreatePlan={recreatePlan}
                  isMealPlanLoading={isMealPlanLoading}
                  planPending={planPending}
                  initialSelectedMeal={initialSelectedMeal}
                  recipes={recipes}
                  weeklyMeals={weeklyMeals}
                  handleSetDietPlan={handleSetDietPlan}
                  selectedDay={selectedDay}
                  setSelectedDay={setSelectedDay}
                  date={date}
                  setDate={setDate}
                  fetchDietPlan={fetchDietPlan}
                  changeInDay={changeInDay}
                  dietPdfUrl={dietPdfUrl}
                  pdfGenerating={pdfGenerating}
                  startDate={startDate}
                  tab={tab}
                />
              )}
            </div>
          </div>

          {adviceList && (
            <FoodPreparingAdvice adviceList={adviceList} day={selectedDay} />
          )}
        </div>
      )}
    </div>
  );
};

export default DietPlan;
